import React, { JSX } from 'react';
import Chip from 'components/atoms/Chip';
import { FacetValue } from 'components/types/FilterTypes';

type SelectedFiltersListProps = {
  activeFilterPanel: string;
  filterDefaults: any;
  filters: any;
  selectedFacetsCount: number;
  query: string;
  removeFilter: Function;
  removeLocationFilters: Function;
  searchType: string;
  selectedFacets: any;
  selectedFilters: any;
  updateQuery: Function;
  clearAllFilters: () => void;
};

// Facets that filter results but should not render a chip.
const HIDDEN_CHIP_CATEGORIES = ['sortfield'];

const SelectedFiltersList = (props: SelectedFiltersListProps): JSX.Element => {
  const {
    filterDefaults,
    filters,
    selectedFacetsCount,
    removeFilter,
    selectedFilters,
    clearAllFilters,
    query,
  } = props;
  const hasNonEmptyArray = Object.values(selectedFilters).some(
    value => Array.isArray(value) && value.length > 0
  );

  return (selectedFacetsCount >= 1 && hasNonEmptyArray) ||
    selectedFilters.acceptingNewPatients === true ||
    selectedFilters.onlineScheduling === true ||
    selectedFilters.availability !== filterDefaults.availability ||
    selectedFilters.gender !== filterDefaults.gender ||
    query ? (
    <>
      {selectedFacetsCount || query ? (
        <div className="selected-filters-list">
          <div className="tag-list">
            {selectedFacetsCount || query ? (
              <button
                className="filter-clear-btn track-search"
                onClick={() => {
                  clearAllFilters();
                }}
                aria-label={`Clear All Filters`}
              >
                Clear all filters
              </button>
            ) : null}
            {Object.keys(selectedFilters).map(key => {
              if (HIDDEN_CHIP_CATEGORIES.includes(key)) return null;
              return Array.isArray(selectedFilters[key])
                ? Object.values(selectedFilters[key])
                    .filter(item =>
                      filterDefaults[key]
                        ? !filterDefaults[key].includes(item)
                        : item
                    )
                    .map(filterValue => {
                      return (
                        <Chip
                          filterName={filterValue as string}
                          filterCategory={key}
                          count={
                            filters[key]?.filter(
                              (facet: FacetValue) =>
                                facet.text ===
                                (filterValue as string).toString()
                            )[0]?.count || 0
                          }
                          removeFilter={removeFilter}
                          key={filterValue as string}
                          label={
                            filters &&
                            filters[key] &&
                            filters[key].find(
                              (o: any) => o.slug === filterValue
                            )
                              ? filters[key].find(
                                  (o: any) => o.slug === filterValue
                                ).name
                              : key === 'onlinescheduling'
                                ? 'Online Scheduling'
                                : key === 'acceptingnewpatients'
                                  ? 'Accepting New Patients'
                                  : ''
                          }
                        />
                      );
                    })
                : null;
            })}
          </div>
        </div>
      ) : null}
    </>
  ) : (
    <></>
  );
};

export default SelectedFiltersList;
